module.exports = __webpack_public_path__ + "img/non-exist.1c81371a.png";